{
    "button.copy": "복사",
    "button.email": "이메일",
    "button.share": "공유",
    "button.sms": "SMS",
    "footer.poweredBy": "<linkText>Ice Cream Social<\/linkText> 제공",
    "footer.privacyPolicy": "개인정보 처리방침",
    "footer.termsAndConditions": "이용약관",
    "offer.hint": "{conversionGoal, plural, one {친구 #명이 구매하면 보상을} two {#친구가 구매하면 보상을} few {#친구가 구매하면 보상을} many {#친구가 구매하면 보상을} other {#친구가 구매하면 보상을}} 드립니다!",
    "optInMessage": "캠페인에 참여하고 친구들과 공유하려면, 이메일 주소를 입력해 주세요. 캠페인 리워드 및 업데이트 소식을 보내드립니다.",
    "order.confirmed": "주문 번호 {orderId}이 확인되었습니다!",
    "order.details": "주문 세부정보 보기",
    "share.email.duplicateError": "이미 추가한 이메일 주소입니다.",
    "share.email.heading": "이메일로 친구 초대하기",
    "share.email.inputLabel": "친구의 이메일 주소",
    "share.email.inputSubmit": "입력 완료",
    "share.email.invitesSubmit": "초대장 보내기",
    "share.email.moreOptions": "다른 공유 방법 보기",
    "share.email.subheading": "아래에 친구의 이메일 주소를 입력하세요",
    "share.general.help": "<bold>이용에 문제가 있으신가요?<\/bold> 앱이 설치되지 않은 경우 열리지 않을 수 있습니다.  대신 개인 링크로 <bold2>공유하기<\/bold2>를 이용해 주세요.",
    "share.general.linkLabel": "개인 링크를 사용하여 어디에나 공유",
    "share.general.otherOptions": "또는 지금 이 플랫폼에서 공유하세요.",
    "thankyou.dismissCTA": "닫기",
    "thankyou.heading": "공유해 주셔서 감사합니다!",
    "thankyou.message": "함께해 주셔서 감사합니다! 캠페인 리워드와 진행 상황을 이메일로 알려드리겠습니다.",
    "thankyou.reminder": "언제든지 이 캠페인 공유를 다시 시작할 수 있습니다.",
    "thankyou.shareCTA": "계속 공유",
    "unlock.consentExplanation": "제공해 주신 정보로 연락드리겠습니다. 언제든지 수신을 취소할 수 있지만, 캠페인 안내나 리워드를 놓칠 수 있습니다.",
    "unlock.consentPolicyExplanation": "개인정보가 어떻게 사용되는지 알아보려면 <linkText> 개인정보 보호 및 쿠키 정책 <\/linkText>을 확인해 주세요.",
    "unlock.emailConsentOptIn": "이메일 수신에 동의합니다",
    "unlock.error.invalidEmail": "유효한 이메일을 입력하세요",
    "unlock.error.noConsent": "캠페인에 참여하려면 이메일 수신에 동의해 주세요",
    "unlock.input": "이메일 주소",
    "unlock.label": "캠페인 참여하기",
    "share.general.copySuccess": "✨ 링크 복사!",
    "consent.button.edit": "수정하기",
    "contact.consent.email": "<underlined>{email}<\/underlined>로 이메일 수신",
    "contact.consent.hint.email": "{email} 주소로 이메일 알림 받기",
    "contact.consent.hint.phone": "{phoneNumber}로 문자 수신",
    "contact.consent.phone": "<underlined>{phoneNumber}<\/underlined>번호로 문자 알림 받기",
    "contact.consent.statement": "입력하신 연락처로 혜택 및 리워드 관련 안내를 드릴 예정입니다. 언제든지 수신 거부가 가능합니다.",
    "contact.error.invalidPhone": "유효한 핸드폰 번호를 입력해주세요",
    "contact.error.requiredPhone": "휴대폰 번호를 입력해주세요",
    "contact.hint.optional": "선택 사항",
    "contact.label.email": "이메일 주소",
    "contact.label.phone": "휴대폰 번호",
    "incentive.continueShopping": "쇼핑 계속하기",
    "incentive.discountCode.copy": "복사하기",
    "incentive.general.codeLabel": "할인을 적용하려면 결제 시 코드를 입력하세요",
    "incentive.general.copySuccess": "✨ 코드가 복사되었습니다!",
    "unlock.continue": "계속 진행하기",
    "unlock.incentive.label": "할인 혜택 받기"
}